<template>
  <v-menu v-if="currentLang">
    <template v-slot:activator="{on}">
      <template v-if="asListTile">
        <v-list-tile>
          <v-list-tile-action
            v-if="!nameOnly"
            class="pointer"
            v-on="on">
            <flag :iso="currentLang.flag"/>
          </v-list-tile-action>

          <v-list-tile-content
            v-if="!flagOnly"
            class="pointer"
            v-on="on">
            <v-list-tile-title>{{ $t(currentLang.name) }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>

      <template v-else>
        <v-btn
          :icon="flagOnly"
          flat
          large
          v-on="on"
        >
          <template v-if="!nameOnly">
            <div :style="flagStyle"><flag :iso="currentLang.flag"/></div>
          </template>

          <template v-if="!flagOnly">
            <span class="pl-3 text-capitalize">{{ $t(currentLang.name) }}</span>
          </template>
        </v-btn>
      </template>
    </template>
    <v-list>
      <v-list-tile
        v-for="lang in languages"
        :key="lang.code"
        @click="changeLanguage(lang)"
      >
        <v-list-tile-title>
          <flag :iso="lang.flag"/>
          {{ $t(lang.name) }}
        </v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import languages from '@/../config/languages'

export default {
  name: 'LanguageSwitcher',

  props: {
    asListTile: {
      type: Boolean,
      default: false
    },
    flagOnly: {
      type: Boolean,
      default: false
    },
    nameOnly: {
      type: Boolean,
      default: false
    },
    flagSize: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      languages: languages,
      loadedLanguages: ['en']
    }
  },

  computed: {
    currentLang () {
      return this.languages.find(item => item.code === this.$i18n.locale)
    },

    flagStyle () {
      return this.flagSize ? `font-size: ${this.flagSize}` : ''
    }
  },

  beforeMount () {
    const lang = localStorage.getItem('language')
    if (lang) {
      this.changeLanguage(this.languages.find(item => item.code === lang))
    }
  },

  methods: {
    async changeLanguage (lang) {
      if (this.$i18n.locale === lang.code) {
        return
      }

      if (!this.loadedLanguages.includes(lang.code)) {
        const messages = require(`@/../lang/${lang.file}`)
        this.$i18n.setLocaleMessage(lang.code, messages.default)
      }

      this.$i18n.locale = lang.code
      localStorage.setItem('language', lang.code)
      this.loadedLanguages.push(lang.code)
      this.$vuetify.rtl = lang.rtl
    }
  }
}
</script>

<style scoped>

</style>
